/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import * as AppStrings from '@touchplan/strings';
import { AppState } from 'src/app/services/app-state.service';
import { IntercomService } from 'src/app/services/intercom.service';

import { DynamicFlagTypes } from '@touchplan/feature-flags';
import { filter, map, Observable } from 'rxjs';
import { TicketEditService } from 'src/app/modules/ticket-edit/ticket-edit.service';
import { analyticsEventsService } from 'src/app/plain-javascript/services/analytics/AnalyticsEventsService';
import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';
import { SupportMenuLinks } from './support-links';

interface IMenuItem {
	icon: string;
	text: string;
	onClick: () => void;
}

@Component({
	selector: 'support-menu',
	templateUrl: './support-menu.component.html',
	styles: ['.nav-bar-dropdown-menu { width: 232px }'], // wider to fit new "TouchplanGO User Guide" in menu
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [FeatureFlagManager],
})
export class SupportMenuComponent implements OnInit {
	public appStrings = AppStrings;

	readonly supportMenuItems: Observable<Array<IMenuItem>> = this.featureFlagManager
		.getFlag$(DynamicFlagTypes.SUPPORT_DROPDOWN_ADDITIONAL_RESOURCE_LINKS_ENABLED)
		.pipe(
			map((isEnabled: boolean) =>
				isEnabled
					? [
							{
								icon: 'help',
								text: AppStrings.SUPPORT_MENU_ADMIN_USER_RESOURCES,
								onClick: () => this.onSupportLinkClicked(SupportMenuLinks.ADMIN_USER_RESOURCES),
							},
							{
								icon: 'help',
								text: AppStrings.SUPPORT_MENU_BASIC_USER_RESOURCES,
								onClick: () => this.onSupportLinkClicked(SupportMenuLinks.BASIC_USER_RESOURCES),
							},
					  ]
					: []
			),
			map((menuItems) => {
				menuItems.push({
					icon: 'help',
					text: AppStrings.SUPPORT_MENU_HELP_CENTER,
					onClick: () => this.onSupportLinkClicked(SupportMenuLinks.HELP_CENTER),
				});

				return menuItems;
			})
		);

	constructor(
		public intercomService: IntercomService,
		private appState: AppState,
		private ticketEditService: TicketEditService,
		private featureFlagManager: FeatureFlagManager
	) {}

	public ngOnInit() {}

	public onOpen() {
		if (this.appState && this.appState.userSync) {
			analyticsEventsService.clickedSupport(this.appState.userSync.$id);
		}
		this.ticketEditService.hideTicketAttachments();
	}

	public onSupportLinkClicked(link: SupportMenuLinks) {
		if (this.appState?.userSync) {
			analyticsEventsService.clickedFaq(this.appState.userSync.$id);
		}

		window.open(link, '_blank');
	}
}
